import { useEffect, useState } from "react";
import { businessInfo } from "@/mocks/siteData";

type FloatingActionsProps = {
  onOpenConsult: () => void;
};

export default function FloatingActions({ onOpenConsult }: FloatingActionsProps) {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 700);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <div className="fixed bottom-24 right-4 z-40 hidden flex-col items-end gap-2 md:bottom-8 md:right-6 md:flex">
        <a
          href={businessInfo.kakao}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="카톡상담"
          className="flex h-12 w-12 items-center justify-center rounded-full bg-[#FEE500] ring-1 ring-black/10 transition-transform duration-300 hover:scale-105 cursor-pointer"
        >
          <i className="ri-kakao-talk-fill text-2xl text-[#3C1E1E]" />
        </a>
        {showTop ? (
          <button
            type="button"
            onClick={scrollTop}
            aria-label="맨 위로"
            className="flex h-12 w-12 items-center justify-center rounded-full border border-background-300/60 bg-background-100/90 text-foreground-700 backdrop-blur-md transition-colors duration-300 hover:border-primary-500 hover:text-primary-400 cursor-pointer"
          >
            <i className="ri-arrow-up-line text-xl" />
          </button>
        ) : null}
      </div>

      <div className="fixed inset-x-0 bottom-0 z-40 flex items-stretch gap-2 border-t border-background-200/60 bg-background-50/95 p-3 backdrop-blur-md md:hidden">
        <a
          href="#diagnosis"
          className="flex flex-1 items-center justify-center whitespace-nowrap rounded-md border border-background-300/60 py-3 text-sm text-foreground-700 cursor-pointer"
        >
          자가진단
        </a>
        <button
          type="button"
          onClick={onOpenConsult}
          className="flex flex-1 items-center justify-center whitespace-nowrap rounded-md bg-primary-500 py-3 text-sm font-medium text-background-50 cursor-pointer"
        >
          상담예약
        </button>
      </div>
    </>
  );
}